import { withInstall } from '@jdesign-vue/utils'
import Monitor from './src/monitor.vue'

export const JdTrackMonitor = withInstall(Monitor)
export * from './src/tools'
export default JdTrackMonitor
